<template>
  <div>
    <v-data-table
      dense
      multi-sort
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-btn rounded small @click="refresh" color="accent" title="Reîncărcare date tabel">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-divider vertical class="mx-4" inset></v-divider>
          <v-spacer></v-spacer>
          <!-- <v-btn small color="primary" rounded @click="openItemDialog" title="Încărcare document" :disabled="user.submitted"> -->
          <v-btn small color="primary" rounded @click="openItemDialog" title="Încărcare document" :disabled="true">
            Încărcare documente
          </v-btn>
          <v-spacer></v-spacer>
          <v-divider vertical class="mx-4" inset></v-divider>
          <!-- <v-btn color="primary" small rounded :disabled="!validSubmission" @click="depunere">Depunere Dosar</v-btn> -->
          <v-btn color="primary" small rounded :disabled="true" @click="depunere">Depunere Dosar</v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item._id="{ item }">
        <span style="display: inline-block; width: 50px" class="text-truncate" :title="item._id">
          {{ item._id }}
        </span>
      </template>
      <template v-slot:item.document="{ item }">
        {{ item.document ? documentTypes[item.document] : 'nedefinit' }}
      </template>
      <template v-slot:item.url="{ item }">
        <a :href="SERVER_URL + item.url" download target="_blank" class="text-decoration-none">
          <v-icon color="primary">mdi-download</v-icon>
        </a>
      </template>
      <template v-slot:item.actions="{ item }">
        <div style="white-space: nowrap">
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
            color="accent"
            title="editeaza fisier"
            :disabled="user.submitted">
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="mr-2"
            @click="deleteItem(item)"
            color="error"
            title="sterge fisier"
            :disabled="user.submitted">
            mdi-delete
          </v-icon>
        </div>
      </template>
      <template v-slot:item.createdAt="{ item }">
        {{ (new Date(item.createdAt)).toLocaleString('ro-RO') }}
      </template>
      <template v-slot:item.updatedAt="{ item }">
        {{ (new Date(item.updatedAt)).toLocaleString('ro-RO') }}
      </template>
    </v-data-table>

    <v-dialog
      persistent
      scrollable
      v-model="itemForm"
      width="500">
      <v-card max-height="75vh">
        <v-card-title>
          <span>{{ itemAction === 'add' ? 'Încărcare' : 'Modificare' }} Document</span>
          <v-spacer></v-spacer>
          <v-btn icon small>
            <v-icon small color="error" @click="closeItemDialog">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="validForm" ref="form">
            <!-- <v-text-field
              v-model="item.title"
              label="Titlu"
              persistent-hint
              hint="Titlu fișier"
              :rules="[rules.required]">
            </v-text-field>
            <v-textarea
              rows="2"
              label="Descriere"
              persistent-hint
              v-model="item.description"
              hint="Descriere fișier"
              :rules="[rules.required]">
            </v-textarea> -->
            <v-file-input
              v-model="item.buffer"
              label="Document"
              persistent-hint
              ref="fileField"
              hint="Click pentru a încărca un document"
              :prepend-icon="null"
              :rules="itemAction === 'add' ? [rules.required, fileTypeValidation] : [() => true, fileTypeValidation]">
            </v-file-input>

            <p class="mt-4">Tip document:</p>
            <v-radio-group v-model="item.document" :mandatory="true">
              <v-radio :disabled="uploadedDocTypes.includes('1')" label="1. Cerere-tip de înscriere Dosar plan de afaceri (format PDF)" value="1"></v-radio>
              <v-radio :disabled="uploadedDocTypes.includes('2')" label="2. Declarația de eligibilitate participant (format PDF)" value="2"></v-radio>
              <v-radio :disabled="uploadedDocTypes.includes('3')" label="3. Certificat/Adeverință de absolvire a unui program de formare antreprenorială specifică economiei sociale (format PDF)" value="3"></v-radio>
              <v-radio :disabled="uploadedDocTypes.includes('4')" label="4. Declarația-angajament de respectare a termenilor și condițiilor concursului planurilor de afaceri (format PDF)" value="4"></v-radio>
              <v-radio :disabled="uploadedDocTypes.includes('5')" label="5. Planul de afaceri format Word editabil" value="5"></v-radio>
              <v-radio :disabled="uploadedDocTypes.includes('6')" label="6. Planul de afaceri format PDF" value="6"></v-radio>
              <v-radio :disabled="uploadedDocTypes.includes('7')" label="7. Bugetul format Excel editabil" value="7"></v-radio>
              <v-radio :disabled="uploadedDocTypes.includes('8')" label="8. Bugetul format PDF" value="8"></v-radio>
              <v-radio :disabled="uploadedDocTypes.includes('9')" label="9. Grafic Gantt de implementare activități format editabil (Excel sau Word)" value="9"></v-radio>
              <v-radio :disabled="uploadedDocTypes.includes('10')" label="10. Grafic Gantt de implementare activități format PDF" value="10"></v-radio>
              <v-radio :disabled="uploadedDocTypes.includes('11')" label="11. Fișele de post format Word" value="11"></v-radio>
              <v-radio :disabled="uploadedDocTypes.includes('12')" label="12. Fișele de post format PDF" value="12"></v-radio>
              <v-radio label="13. Documente personale în format PDF (aici se vor încărca toate Documentele personale format PDF, conform Metodologiei. Pot fi încărcate mai multe documente separate)" value="13"></v-radio>
            </v-radio-group>

          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-alert type="error" v-if="message" dismissible @input="alertChanged">{{ message }}</v-alert>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="closeItemDialog">Închide</v-btn>
          <v-btn color="primary" @click="saveItem">Încarcă document</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      scrollable
      v-model="deleteItemDialog"
      width="500">
      <v-card max-height="75vh">
        <v-card-title>Confirmați ștergerea?</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="cancelDelete">Anulează ștergerea</v-btn>
          <v-btn color="primary" @click="confirmDelete">Șterge Fișier</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-model="confirmDialog"
      width="750">
      <v-card max-height="75vh">
        <v-card-title>Confirmați depunerea?</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-6">
          <v-alert type="warning" border="left" prominent>
            Sunteti sigur(a) ca doriti sa efectuati depunerea? Nu veti mai putea reveni asupra documentelor deja incarcate si nu veti mai putea incarca alte documente.
          </v-alert>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="cancelDepunere">Nu, nu doresc sa efectuez depunerea</v-btn>
          <v-btn color="primary" @click="confirmDepunere">Da, doresc sa efectuez depunerea</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-model="successDialog"
      width="500">
      <v-card max-height="75vh">
        <v-card-title>Felicitari!</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-6">
          <v-alert type="success" border="left" prominent>
            Depunere efectuata cu succes.
          </v-alert>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeSuccess">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SERVER_URL from '@/config'

export default {
  name: 'MyFilesComponent',

  data: () => ({
    SERVER_URL,
    headers: [
      {
        text: 'id',
        value: '_id',
        align: 'start',
        sortable: false,
        filterable: false
      },
      {
        text: 'document',
        value: 'document',
        align: 'left',
        sortable: true,
        filterable: true
      },
      // {
      //   text: 'denumire',
      //   value: 'title',
      //   align: 'left',
      //   sortable: true,
      //   filterable: true
      // },
      // {
      //   text: 'descriere',
      //   value: 'description',
      //   align: 'left',
      //   sortable: true,
      //   filterable: true
      // },
      {
        text: 'data',
        value: 'createdAt',
        align: 'start',
        sortable: true,
        filterable: true
      },
      // {
      //   text: 'tip',
      //   value: 'type',
      //   align: 'start',
      //   sortable: true,
      //   filterable: true
      // },
      {
        text: 'descărcare',
        value: 'url',
        align: 'start',
        sortable: false,
        filterable: false
      },
      {
        text: 'acțiuni',
        value: 'actions',
        sortable: false,
        filterable: false
      }
    ],
    item: {
      _id: null,
      title: null,
      description: null,
      document: null,
      dataType: 'application',
      buffer: null
    },
    itemForm: false,
    itemAction: 'add',
    validForm: true,
    deleteItemDialog: false,
    deleteItemID: null,
    rules: {
      required: val => !!val || 'Câmpul nu poate fi gol!'
    },
    message: null,
    documentTypes: Object.freeze({
      1: '1. Cerere-tip de înscriere Dosar plan de afaceri (format PDF)',
      2: '2. Declarația de eligibilitate participant (format PDF)',
      3: '3. Certificat/Adeverință de absolvire a unui program de formare antreprenorială specifică economiei sociale (format PDF)',
      4: '4. Declarația-angajament de respectare a termenilor și condițiilor concursului planurilor de afaceri (format PDF)',
      5: '5. Planul de afaceri format Word editabil',
      6: '6. Planul de afaceri format PDF',
      7: '7. Bugetul format Excel editabil',
      8: '8. Bugetul format PDF',
      9: '9. Grafic Gantt de implementare activități format editabil (Excel sau Word)',
      10: '10. Grafic Gantt de implementare activități format PDF',
      11: '11. Fișele de post format Word',
      12: '12. Fișele de post format PDF',
      13: '13. Documente personale în format PDF (aici se vor încărca toate Documentele personale format PDF, conform Metodologiei. Pot fi încărcate mai multe documente separate)'
    }),
    confirmDialog: false,
    successDialog: false
  }),

  watch: {
    itemForm (value) {
      if (value && this.itemAction === 'add') {
        this.$nextTick(() => {
          this.resetForm()
        })
      }
    }
  },

  computed: {
    user () {
      return this.$store.getters.user
    },
    items () {
      return this.$store.getters.filesItems
    },
    uploadedDocTypes () {
      return this.$store.getters.uploadedDocTypes
    },
    validSubmission () {
      return this.uploadedDocTypes.length === 13 && !this.user.submitted
    },
    options: {
      get () {
        return this.$store.getters.filesOptions
      },
      set (value) {
        this.$store.dispatch('setFilesOptions', value)
      }
    },
    totalItems () {
      return this.$store.getters.filesTotal
    },
    loading () {
      return this.$store.getters.filesLoading
    }
  },

  methods: {
    depunere () {
      /* eslint-disable no-unreachable */
      return
      this.confirmDialog = true
    },
    cancelDepunere () {
      this.confirmDialog = false
    },
    async confirmDepunere () {
      /* eslint-disable no-unreachable */
      return
      await this.$store.dispatch('depunere')
      this.confirmDialog = false
      this.successDialog = true
    },
    closeSuccess () {
      this.successDialog = false
    },
    fileTypeValidation (file) {
      if (!file) return true

      const type = file?.type ?? ''

      switch (this.item.document) {
        // word
        case '5':
        case '11': return type.includes('word') || type.includes('docx') || 'Fisierul trebuie sa fie in format Microsoft Word'

        // pdf
        case '1':
        case '2':
        case '3':
        case '4':
        case '6':
        case '8':
        case '10':
        case '12':
        case '13': return type.includes('pdf') || 'Fisierul trebuie sa fie in format PDF'

        // excel
        case '7': return type.includes('xls') || type.includes('sheet') || type.includes('sheet') || 'Fisierul trebuie sa fie in format Microsft Excel'

        // word or excel
        case '9': return type.includes('word') || type.includes('docx') || type.includes('xls') || type.includes('sheet') || type.includes('sheet') || 'Fisierul trebuie sa fie in format Microsft Excel sau Microsoft Word'
        default: return true
      }
    },
    refresh () {
      this.$store.dispatch('fetchFiles')
      this.$store.dispatch('fetchDocumentTypes')
    },
    resetForm () {
      this.$refs.form.resetValidation()
      this.item = Object.assign(this.item, {}, JSON.parse(JSON.stringify(defaultItem)))
      this.itemAction = 'add'
    },
    closeItemDialog () {
      this.itemForm = false
      this.item = Object.assign(this.item, {}, JSON.parse(JSON.stringify(defaultItem)))
      this.resetForm()
      this.message = null
    },
    openItemDialog () {
      /* eslint-disable no-unreachable */
      return
      this.itemForm = true
      this.itemAction = 'add'
    },
    async saveItem () {
      /* eslint-disable no-unreachable */
      return
      const valid = this.$refs.form.validate()
      if (valid) {
        const payload = Object.assign({}, this.item)
        const result = await this.$store.dispatch('saveFile', payload)
        if (result === true) {
          this.closeItemDialog()
        } else {
          this.message = 'Ne pare rău. A apărut o eroare la procesarea cererii...'
        }
      }
    },
    editItem (item) {
      this.item._id = item._id

      this.item.title = item.title
      this.item.description = item.description
      this.item.document = item.document

      this.itemAction = 'edit'
      this.itemForm = true
    },
    deleteItem (item) {
      this.deleteItemID = item._id
      this.deleteItemDialog = true
    },
    confirmDelete () {
      const payload = this.deleteItemID
      this.$store.dispatch('deleteFile', payload)
      this.deleteItemID = null
      this.deleteItemDialog = false
    },
    cancelDelete () {
      this.deleteItemID = null
      this.deleteItemDialog = false
    },
    alertChanged ($event) {
      if (!$event) this.message = null
    }
  }
}

const defaultItem = {
  _id: null,
  title: null,
  document: null,
  description: null,
  buffer: null,
  dataType: 'application'
}
</script>
